import React, { useContext } from 'react';
import { getAppEnv } from '../../../../../config/env';
import './SwapIcon.css';
import {
  CabsLandingContext,
  CabsLandingDispatchContext
} from '../../../../CabsLandingContext';
import {
  CAB_FROM_AIRPORT,
  CAB_TO_AIRPORT,
  isAirportCheck,
  isOutstationCheck
} from '../../../../constants/tripTypes';
import {
  SET_TRAVELFOR,
  SET_SOURCE_CITY,
  SET_DESTINATION_CITY
} from '../../cabsLandingPageState';
import { MOB_CABS_LANDING_SWAP_SEARCH_PARAMS } from '../../../../constants/omnitureConstants';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export const SwapIcon = ({
  showIcon,
  styleObject = {},
  imageStyleObject = {}
}) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const dispatch = useContext(CabsLandingDispatchContext);
  const { trackTemplateEvent } = cabsLandingContext;

  const {
    travelFor,
    activeStopOver,
    widget,
    stopOvers,
    sourceCity,
    destinationCity
  } = cabsLandingContext;

  const setTravelFor = trptype => {
    dispatch && dispatch({ type: SET_TRAVELFOR, newStateValue: trptype });
  };
  const setSourceCity = sourceCity => {
    dispatch && dispatch({ type: SET_SOURCE_CITY, newStateValue: sourceCity });
  };
  const setDestinationCity = destinationCity => {
    dispatch &&
      dispatch({ type: SET_DESTINATION_CITY, newStateValue: destinationCity });
  };
  const swapIconId = `${travelFor}_swap_icon`;

  const airportLocationSwap = () => {
    if (travelFor === CAB_FROM_AIRPORT) setTravelFor(CAB_TO_AIRPORT);
    if (travelFor === CAB_TO_AIRPORT) setTravelFor(CAB_FROM_AIRPORT);
  };

  const onOutstationLocationSwap = () => {
    const fromCityInfo = sourceCity;
    setSourceCity(destinationCity);
    setDestinationCity(fromCityInfo);
  };

  const onSwap = () => {
    switch (true) {
      case isOutstationCheck(travelFor):
        onOutstationLocationSwap();
        break;
      case isAirportCheck(travelFor):
        airportLocationSwap();
        break;
      default:
        break;
    }
  };

  const swap = () => {
    const element = document.getElementById(swapIconId);
    if (element) {
      element.style.transitionDuration = '.2s';
      element.style.transform = 'rotate(180deg)';
    }
    setTimeout(() => {
      onSwap();
      if (element) {
        element.style.transitionDuration = '0s';
        element.style.transform = 'rotate(0deg)';
      }
    }, 200);
    trackTemplateEvent(MOB_CABS_LANDING_SWAP_SEARCH_PARAMS);
  };
  return showIcon ? (
    <div id="swap_icon" className="makeRelative" style={styleObject}>
      <img
        className="makeAbsolute"
        id={swapIconId}
        onClick={swap}
        style={imageStyleObject}
        src={`${PUBLIC_URL}/static/public/swap.webp`}
        height={35}
        width={35}
        alt="loc_swap"
      />
    </div>
  ) : (
    <div id="swap_icon" className="makeRelative"></div>
  );
};
